export default __webpack_public_path__ + "static/software_poster_1-a63f66f7bce06e3c77c79e4347a5949e.png";